import { fuzzyMatch } from "@thi.ng/arrays";
import { $iter } from "../iterator";
import { filter } from "./filter";
export function filterFuzzy(...args) {
    const iter = args.length > 1 && $iter(filterFuzzy, args);
    if (iter) {
        return iter;
    }
    const query = args[0];
    const { key, equiv } = (args[1] || {});
    return filter((x) => fuzzyMatch(key != null ? key(x) : x, query, equiv));
}
